export function getLocationPermission(
  onPermitted: (result: PermissionStatus) => void,
  onNotPermitted: () => void,
) {
  if (navigator.geolocation && navigator.permissions) {
    navigator.permissions
      .query({name: 'geolocation'})
      .then((result) => onPermitted(result))
  } else {
    onNotPermitted()
  }
}

export function getMapStyle(region: string, mapName: string, apiKey: string) {
  return `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`
}
